import React, { useEffect } from "react";
import "./inventoryManagement.css";
import report_analytic_img1 from "assets/inventory/report_analytic1.png";
import report_analytic_img2 from "assets/inventory/report_analytic2.jpg";
import report_analytic_img3 from "assets/inventory/report_analytic3.jpg";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";
import FaqBlock from "Component/FaqBlock/faqBlock";

const ReportAnalytics = () => {
  const questions = [
    "What are real estate inventory analytics reports?",
    "How do real estate inventory analytics reports benefit real estate professionals?",
    "How frequently should real estate professionals review inventory analytics reports?",
    "Can inventory analytics reports identify emerging market trends?  ",
  ];
  const answers = [
    "Real estate inventory analytics reports are data-driven documents that provide insights into the availability and status of properties within a specific market. They track metrics such as the number of properties for sale or rent, the average number of days a property stays available in the market, price trends, and absorption rates. By analyzing current inventory levels, demand, and market dynamics, these reports help stakeholders make informed decisions.",
    "Real estate inventory analytics reports benefit real estate professionals by providing accurate data on property availability, market trends, and pricing. This enables informed decision-making, efficient inventory management, optimized pricing strategies, automated reports, real-time insights, and improved client service, ultimately leading to increased sales and profitability, all while saving your time.",
    "Real estate professionals should review inventory analytics reports weekly. This frequency ensures they stay updated on market trends, pricing strategies, and property availability. Regular reviews allow for timely adjustments to marketing efforts, better client service, and more informed decision-making. Staying updated with inventory analytics is not just important; it's crucial for maintaining a competitive edge in the fast-paced real estate market.",
    "Yes, inventory analytics reports can identify emerging market trends by analyzing patterns in stock levels, sales data, and customer demand. These reports are a reliable tool that helps businesses forecast future trends, adjust inventory strategies, and capitalize on market opportunities, ensuring they stay competitive and responsive to changes in consumer behaviour.",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Report Analytics | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Track Your Inventory Performance with Realtor Desk"
              subTitle="The Realtor Desk allows you to gain in-depth insights into your inventory, helping you make informed decisions. Monitor the status of each property, track performance, and optimize your strategy for better results."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="In-Depth Real Estate Inventory Analytics with The Realtor Desk CRM"
                description="The Realtor Desk provides comprehensive inventory reports that go beyond basic overviews. Gain detailed insights into inventory performance, enabling you to make data-driven decisions, learn from past trends, and forecast future outcomes with confidence."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="Understand Current Inventory State"
                title="Stay Updated with Your Inventory Availability"
                description="The Realtor Desk gives you a detailed, real-time view of your inventory, offering insights into project-wise, tower-wise, and unit-wise availability, ensuring you stay informed and manage your assets effectively."
                image={report_analytic_img1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Inventory Movement and Velocity"
                title="Understand Inventory Movement and Velocity"
                description="The Realtor Desk offers full visibility into inventory movement at the project, tower, and unit levels. It keeps you updated with real-time sales patterns and sales velocity, enabling you to make informed decisions and optimize your business strategy."
                image={report_analytic_img2}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Analyze Inventory Performance"
                title="Analyze Inventory Sales Across 30+ Attributes"
                description="Understanding patterns in your sales is one of the most effective ways to truly comprehend your customers and market. With Realtor Desk, you can analyze sales based on project, configuration, and over 30 attributes, providing valuable business insights for sales forecasting, future development, and marketing strategies."
                image={report_analytic_img3}
                imagePosition="right"
            />
            <FaqBlock
                questions={questions}
                answers={answers}
            />
          </div>
      </div>
    </>
  );
};

export default ReportAnalytics;
